import { render, staticRenderFns } from "./UserWisePickup.vue?vue&type=template&id=3c9651ba&"
import script from "./UserWisePickup.vue?vue&type=script&lang=js&"
export * from "./UserWisePickup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports